export enum Permission {
  PickupSettingsPickupSettingsModify = 'pickup_settings_shoppers_retailer_settings.modify',
  PickupSettingsPickupSettingsView = 'pickup_settings_shoppers_retailer_settings.view',
}
